import type { FaireProductEntity } from "../../entity_types/product";

export const p_535bv2wvzp: FaireProductEntity = {
  token: "p_535bv2wvzp",
  type: "product",
  name: "Passion Orange Guava",
  brandToken: "b_d2aykgrbmk",
  brandName: "Just Made Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/8aa8a039a50d1a01ab53791b9a23f598c989c415e8365766223d7d7e9b8cb616.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7039b1a1b085b8173292c33cd121afde0ca89dc365905e60f25e4c876eb1fb65.png",
    "https://cdn.faire.com/fastly/93128993b05654a9993eb7d504d95dd4616731f420bd11f6d619ec81d7b52a8b.png",
    "https://cdn.faire.com/fastly/4f1592a4488d8c77170d05ffb65d89c0f38c9e4df6227123b59900a638a47f39.png",
    "https://cdn.faire.com/fastly/2540c40f3af7b63548ef3abf7dcbe6ad816dcf1ff3c7b01f3fe4ba838a745337.png",
  ],
  priceDollars: 4.09,
  description:
    "\nIntroducing Just Made’s Passion Orange Guava—a tropical drink that tastes like paradise! Made with sun-ripened oranges, pink guava, sweet pears, and pineapple, it’s a perfect blend. Additionally, we’ve added passion fruit for a tangy twist and acerola cherries, which are packed with vitamin C.\n\nMoreover, this refreshing drink contains only natural ingredients, making it a delicious way to stay healthy while enjoying bold, fruity flavors. So, take a sip and escape to the tropics!\n\nSOLD BY THE CASE, PER CASE IS 8 BOTTLES.\n\n30–40+ days shelf life upon arrival\n",
  tags: [],
  msrpDollars: 8.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:36.414Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
